<template>
  <div class="pb-2 grey lighten-3 d-flex flex-column" style="height: 100%">
    
    <!-- header -->
    <div v-if="$slots.header || back" class="white px-2">
      <div class="d-flex align-center">
        <slot name="header"></slot>
        <div v-if="back"
          class="ml-auto mr-2 d-flex align-center green--text text--darken-2 text-subtitle-2" 
          @click="$router.back()"
        >
          <v-icon small color="green darken-2">mdi-chevron-left</v-icon>
          Back
        </div>
      </div>
    </div>

    <!-- body -->
    <div v-if="!nobody" class="flex-grow-1 mx-2 mt-2" style="overflow-y: auto;">
      <slot>
        <div class="pa-2 white rounded-lg">
          <h3 class="mb-2">Content</h3>
          Lorem ipsum dolor est...
        </div>
      </slot>
    </div>

    <div v-else class="flex-grow-1"/>

    <!-- footer -->
    <div v-if="$slots.footer" class="mt-2 mb-n2 flex-grow-0">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    back: { 
      type: Boolean,
      default: false,
    },

    nobody: { 
      type: Boolean,
      default: false,
    },

    subscroll: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
